import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQantasComponent } from './simple-icons-qantas.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQantasComponent ],
    exports:      [ SimpleIconsQantasComponent ],
    bootstrap:    []
})
export class SimpleIconsQantasModule {}
